import * as messagesSV from "../../lang/compiled/sv.json";
import * as widgetsSV from "widgets/lang/sv.json";

export function getLocaleMessages(locale: "sv" | "en") {
  if (locale === "en") {
    return {};
  }
  return { ...messagesSV, ...widgetsSV };
}
